"use strict";

exports.__esModule = true;
exports.default = void 0;

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t-moz-appearance: text-field;\n\t\t\t&::-webkit-inner-spin-button {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t&::-webkit-outer-spin-button {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tappearance: none;\n\t-moz-appearance: textfield; /* DO NOT RE-ORDER */\n\tfont-family: ", ";\n\tborder-radius: ", ";\n\tborder: ", " solid\n\t\t", " !important;\n\tbackground-color: ", ";\n\tpadding: 0 ", " !important;\n\toutline: none;\n\theight: 2.75rem !important;\n\tmin-height: 2.75rem !important;\n\twidth: ", ";\n\tmargin: 0.5rem 0 !important;\n\tline-height: normal !important;\n\tvertical-align: top;\n\tdisplay: inline-block;\n\n\t&:focus {\n\t\tborder-color: ", " !important;\n\t\tbox-shadow: ", ";\n\t}\n\n\t&:disabled {\n\t\tcolor: ", ";\n\t\t-webkit-text-fill-color: ", ";\n\t\tborder-color: ", " !important;\n\t\tbackground-color: ", ";\n\t}\n\n\t&::placeholder {\n\t\tfont-family: ", ";\n\t\tcolor: ", ";\n\t}\n\n\t", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Input = _styledComponents.default.input(_templateObject(), _vars.default.fontStackBold, _vars.default.borderRadius, _vars.default.borderWidth, function (props) {
  return props.hasError ? _colors.default.error : _colors.default.borderColor;
}, _colors.default.white, _spacing.default.s2, function (props) {
  return props.fullWidth ? '100%' : 'auto !important';
}, _colors.default.borderFocus, _vars.default.boxShadow, _colors.default.disabled, _colors.default.disabled, _colors.default.disabledOutline, _colors.default.disabledBackground, _vars.default.fontStackNormal, _colors.default.placeholder, function (props) {
  return props.type === 'number' && (0, _styledComponents.css)(_templateObject2());
});

Input.displayName = 'Input';
Input.propTypes = {
  hasError: _propTypes.bool,
  fullWidth: _propTypes.bool
};
Input.defaultProps = {
  hasError: false,
  fullWidth: false
};
/** @component */

var _default = Input;
exports.default = _default;